import { Theme, styled } from "@mui/material"
import { m, motion } from "framer-motion";

export const getScrollbarStyles = (theme: Theme) => ({
    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
        backgroundColor: theme.palette.customBackground.main,
    },
    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
        borderRadius: 8,
        backgroundColor: theme.palette.primary.main,
        minHeight: 24,
        border: `5px solid ${theme.palette.customBackground.main}`,
    },
    "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
        backgroundColor: theme.palette.primary.light,
    },
    "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
        backgroundColor: theme.palette.primary.light,
    },
    "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.primary.light,
    },
    "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
        backgroundColor: theme.palette.customBackground.main,
    },
});

export const StyledMotionDiv = styled(m.div) <{ theme: Theme }>`
overflow: auto;
&::-webkit-scrollbar {
  background-color: ${({ theme }) => theme.palette.customBackground.main};
}
&::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  min-height: 24px;
  border: 5px solid ${({ theme }) => theme.palette.customBackground.main};
}
&:hover::-webkit-scrollbar-thumb {
  background-color: ${({ theme }) => theme.palette.primary.light};
}
`;

export const AnimatedWrapper = styled(m.div) <{ theme: Theme }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* l'altezza sarà animata via Framer Motion */
`;

export const ScrollContainer = styled('div') <{ theme?: Theme }>`
  height: 100%; /* prende tutta l'altezza del wrapper */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
 
  &::-webkit-scrollbar {
    width: 12px;
    background-color: ${({ theme }) => theme?.palette.customBackground.main};
  }
 
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: ${({ theme }) => theme?.palette.primary.main};
    min-height: 24px;
    border: 5px solid ${({ theme }) => theme?.palette.customBackground.main};
  }
 
  &:hover::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme?.palette.primary.light};
  }
`;